import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sky-detail',
  templateUrl: './sky-detail.component.html',
  styleUrls: ['./sky-detail.component.scss'],
})
export class SkyDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {}

}
